import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import type { Area, CropperProps } from 'react-easy-crop'
import CropperImport from 'react-easy-crop'
import { Modal } from '../Modal/Modal'
import { getCroppedImg } from './cropImage'

const Cropper = CropperImport as unknown as React.ComponentType<Partial<CropperProps>>

type AvatarCropModalProps = {
  imageSrc: string
  fileName: string
  onCancel: () => void
  onConfirm: (blob: Blob) => void
}

export const AvatarCropModal: React.FC<AvatarCropModalProps> = ({ imageSrc, fileName, onCancel, onConfirm }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null)
  const [saving, setSaving] = useState(false)

  const handleSave = async () => {
    if (!croppedAreaPixels) {
      return
    }
    setSaving(true)
    try {
      const blob = await getCroppedImg(imageSrc, croppedAreaPixels)
      onConfirm(blob)
    } finally {
      setSaving(false)
    }
  }

  const header = (
    <div>
      <h5 className='mb-1'>Adjust photo</h5>
      <div className='paragraph-medium zocks-text-gray-600'>Drag to reposition. Use the slider to zoom.</div>
    </div>
  )

  const body = (
    <div className='d-flex flex-column gap-3'>
      <div className='ratio ratio-1x1'>
        <Cropper
          image={imageSrc}
          cropShape='round'
          aspect={1}
          showGrid={false}
          crop={crop}
          zoom={zoom}
          onCropChange={setCrop}
          onCropComplete={(_area, areaPixels) => setCroppedAreaPixels(areaPixels)}
          onZoomChange={setZoom}
        />
      </div>
      <div className='d-flex align-items-center justify-content-center gap-2 zocks-text-gray-600 paragraph-medium'>
        <i className='bi bi-file-earmark' />
        {fileName}
      </div>
      <div className='d-flex align-items-center gap-2'>
        <i className='bi bi-dash-lg' />
        <Form.Range min={1} max={3} step={0.1} value={zoom} onChange={(e) => setZoom(Number(e.target.value))} />
        <i className='bi bi-plus-lg' />
      </div>
    </div>
  )

  return (
    <Modal
      centered
      show
      onHide={onCancel}
      header={header}
      body={body}
      showFooterActions
      footerPrimaryActionTitle='Save photo'
      footerPrimaryActionLoading={saving}
      onFooterPrimaryAction={handleSave}
      onFooterSecondaryAction={onCancel}
    />
  )
}
